import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
    Button,
    Card,
    CardBody,
    CardTitle,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    Label,
    Modal,
    Nav,
    NavItem,
    NavLink,
    Row,
    TabContent,
    TabPane,
    Table,
} from "reactstrap";
import {
    GET_RP_TPA_DAILY_REPORT,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import PropTypes from "prop-types";
import classnames from "classnames";
import moment from "moment";
import TPADailyDetail from "./TPADailyDetail";
import TabTwoTPADailyDetail from "./TabTwoTPADailyDetail";

function TabTPADaily(props) {
    let history = useHistory();
    let { pid } = useParams();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState("1");
    const searchObj = {
        PID: pid,
        TPA_FINAL_ALLOCATION_PID: null,
        INCLUDE_TPA_FINAL_ALLOCATION: true,
    }
    const [searchModel, setSearchModel] = useState(searchObj);

    const model = {
        PID: pid,
        SUMMARYREPORT_PID: "",
        SUMMARYREPORT_REV: "",
        TPADAILY_APPROVE: null,
        TPADAILY_LEVEL: "",
        SUMMARYREPORT_DATE: new Date(),
        BALANCESHIPPER_NAME: "",
        BALANCESHIPPER_PID: "",
        TPA_FINAL_ALLOCATION_PID: null,
        REMARK: "",
        LEADERSHIFT_FLAG: 0,
    }
    const [modelDevice, setModelDevice] = useState(model);

    //onInit//
    useEffect(function () {
        fetchData();
    }, []);
    //onInit//

    const fetchData = async () => {
        // dispatch(loadingAction.showLoading());
        try {
            let res = await post(GET_RP_TPA_DAILY_REPORT, searchModel);
            // console.log(res);
            setModelDevice(res.data.rpTPADailyList[0]);
        } catch (error) {
            dispatch(messageAction.showMessage(error.message));
        }
        // dispatch(loadingAction.hideLoading());
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                                        <h1 className="mb-sm-0 font-size-20">
                                            TPA Daily ( Detail )
                                        </h1>
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">
                                                    <Link to="#" style={{ color: "#556ee6" }}>
                                                        Report
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item">
                                                    <Link to="/tpa-daily-report" style={{ color: "#556ee6" }}>
                                                        TPA Daily
                                                    </Link>
                                                </li>
                                                <li className="breadcrumb-item active">
                                                    TPA Daily ( Detail )
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                    <hr />

                                    <Row className="mt-4">
                                        <Nav tabs>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: activeTab === "1",
                                                    })}
                                                    onClick={() => {
                                                        setActiveTab("1");
                                                        // dataConfirmModal(true);
                                                    }}
                                                >
                                                    TPA Daily
                                                </NavLink>
                                            </NavItem>
                                            <NavItem>
                                                <NavLink
                                                    style={{ cursor: "pointer" }}
                                                    className={classnames({
                                                        active: activeTab === "2",
                                                    })}
                                                    onClick={() => {
                                                        setActiveTab("2");
                                                        // dataConfirmModal(true);
                                                    }}
                                                >
                                                    TPA Final Allocation ( Day-3 )
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </Row>

                                    <Row>
                                        <TabContent
                                            activeTab={activeTab}
                                            className="p-3 text-muted"
                                        >
                                            <TabPane tabId="1">
                                                <TPADailyDetail tpaDailyReportPid={pid} />
                                            </TabPane>

                                            <TabPane tabId="2">
                                                <TabTwoTPADailyDetail tpaDailyReportPid={modelDevice.TPA_FINAL_ALLOCATION_PID} date={modelDevice.SUMMARYREPORT_DATE}/>
                                            </TabPane>
                                        </TabContent>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div >
        </React.Fragment >
    );
}



TabTPADaily.propTypes = {
    t: PropTypes.any,
};


export default TabTPADaily;
